import validationFunctions from '../../utils/validation';

const functions = validationFunctions;

export const validators = {
  Part_C_Last_4_Digits_of_SSN__c: functions.validateSSN,
};
